import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import {
  getAuditFiles,
  getAuditRowsByFileName,
  getSearchData,
  getSearchRecommendations,
} from "../../api/Service";
import refresh from "../../assests/refresh.png";
import SearchIcon from "../../assests/search-lg.png";
import { FilterLines } from "../../assests/svgImages/Images";
import CloseFilter from "../../assests/x-close.png";
import { extractFileName } from "../../utils/util";
import WorkFlowFilters from "../filters";
import "./Navbar.css";
import { Spinner } from "../../common/Helper";
import InfiniteScroll from "../../../codercompanion/components/infinite-scroll";

function Navbar({
  updatedAuditRows,
  handleRefreshClick,
  setAuditDetails,
  setIsRowsLoading,
  getAuditRowsByFilter,
  setHasMore
}) {
  const [showModal, setShowModal] = useState(false);
  const [searchEpisodeIdentifier, setSearchEpisodeIdentifier] = useState("");
  const [recommendations, setRecommendations] = useState([]);
  const [isRecommendationsLoading, setIsRecommendationsLoading] =
    useState(false);
  const [auditFiles, setAuditFiles] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState({
    insurer_identifier: [],
    priority_value: [],
    status: [],
    file_type: [],
    coder_name: [],
    admission_date: null,
    separation_date: null,
    load_id: []
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMany, setHasMany] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectAllFiles,setSelectAllFiles] = useState(false);

  const toggleModal = () => setShowModal(!showModal);
  const fetchRecommendations = useCallback(
    _.debounce((identifier) => {
      setIsRecommendationsLoading(true)
      getSearchRecommendations(identifier)
        .then((res) => {
          const { audited_rows } = res.meesage;
          setRecommendations(audited_rows);
        })
        .catch((err) =>
          console.error("Search Recommendations Error::", err.message)
        )
        .finally(() => setIsRecommendationsLoading(false));
    }, 500),
    []
  );
  const handleSearchRecommendClick = (rowId) => {
    setSearchEpisodeIdentifier(rowId);
    getSearchResults(rowId);
  };
  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchEpisodeIdentifier(value);
    if (value) {
      fetchRecommendations(value);
    } else {
      setRecommendations([]);
      setIsRecommendationsLoading(false);
    }
  };

  const getSearchResults = (searchData) => {
    setIsRowsLoading(true);
    getSearchData(searchData)
      .then((response) => {
        updatedAuditRows(response.meesage.audited_rows);
        setAuditDetails({});
        setSearchEpisodeIdentifier("");
        setHasMore(false)
        setRecommendations([]);
      })
      .catch((err) => console.error("Search Results Error::", err.message))
      .finally(() => {
        setIsRowsLoading(false);
      });
  };

  const handleFilterClick = async (latestFilters = {}) => {
    const filters = { ...latestFilters, load_id: appliedFilters.load_id }
    setAppliedFilters(filters);
    getAuditRowsByFilter(filters);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      getSearchResults(searchEpisodeIdentifier);
    }
  };

  const arraysHaveSameElements = (arr1,arr2)=>{
    if (arr1.length !== arr2.length) {
      return false;
    }
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    for (let item of set1) {
      if (!set2.has(item)) {
        return false;
      }
    }
    return true;
  }

  function handleSelectChange(event, fileName) {
    console.log('CHANGE::',fileName)
    const { value } = event.target;
    let selectedFields = [];
    let selectedFileNames = [];
    if (event.target.checked) {
      selectedFields = [...appliedFilters.load_id, value];
      selectedFileNames = [...appliedFilters.file_type, fileName];
    } else {
      selectedFields = [...appliedFilters.load_id];
      selectedFileNames = [...appliedFilters.file_type]
      const indexOfID = selectedFields.indexOf(value);
      const indexOfFiletype = selectedFileNames.indexOf(fileName);
      selectedFields.splice(indexOfID,1)
      selectedFileNames.splice(indexOfFiletype,1)
    console.log('CHANGE::1',selectedFields)
  }
    const filters = {...appliedFilters, load_id: selectedFields,file_type:selectedFileNames}
    const allLoadIds=[];
    const allFileNames = [];
    auditFiles.forEach((file)=>{
        allLoadIds.push(file.load_id);
        allFileNames.push(extractFileName(file.file_name));
    })
    console.log("IDS::::",allLoadIds,selectedFields);

    if (
      arraysHaveSameElements(allLoadIds, selectedFields) &&
      arraysHaveSameElements(allFileNames, selectedFileNames)
    ) {
      setSelectAllFiles(true);
    } else {
      setSelectAllFiles(false);
    }
    setAppliedFilters(filters)
    getAuditRowsByFilter(filters); 
  }
  const handleBreadCrumbClose = (key) => {
    handleFilterClick({ ...appliedFilters, [key]: [] });
  };

  const handleSelectAllCheckboxes = (e)=>{
    const {checked} = e.target;
    let selectedFields = [];
    let selectedFileNames = [];
    setSelectAllFiles(checked);
    if (checked){
      console.log('ALL:::',e.target.checked,auditFiles)
      auditFiles.forEach((file) => {
        selectedFields.push(file.load_id);
        selectedFileNames.push(extractFileName(file.file_name));
      });
    }
    else{
      selectedFields = []
      selectedFileNames = []
    }
    const filters = {...appliedFilters, load_id: selectedFields,file_type: selectedFileNames};
    console.log('FILTERS::::',filters)
    setAppliedFilters(filters);
    getAuditRowsByFilter(filters);
  }

// key is to match with appliedFilters keys
  const breadCrumbs = [
    { label: "Status", key: "status" },
    { label: "Priority Value", key: "priority_value" },
    { label: "Insurer Identifier", key: "insurer_identifier" },
  ];
  console.log("APPLIED:::", appliedFilters,auditFiles)
  const getData = async(page, load_more) => {
    try {
      setIsLoading(true);
      const response = await getAuditFiles(page);
      console.log("AUDIT_FILES:::", response);
      if (load_more) {
        setAuditFiles([...auditFiles, ...response.message.audited_files]);
      } else {
        setAuditFiles(response.message.audited_files);
      }
      setHasMany(true);
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
    } catch (error) {
      console.error("Error fetching audit files:", error);
      setHasMany(false);
      if (!load_more) {
        setAuditFiles([]);
      }
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getData(1);
  }, []);
  return (
    <div className="navbar">
      <div className="navbar-left-section">
        <input
          className="navbar-left-checkbox"
          type="checkbox"
          checked={selectAllFiles}
          onChange={handleSelectAllCheckboxes}
        />
        <Dropdown className="hcp-file-dropdown-webworkflow">
          <Dropdown.Toggle id="dropdown-basic">Select All</Dropdown.Toggle>
          <Dropdown.Menu className="webworkflow-dropdown-menu">
            <Form>
              {auditFiles.map((item) => (
                <Form.Check
                  key={item.load_id}
                  type="checkbox"
                  label={`${item.start_date} - ${
                    item.end_date
                  } (${extractFileName(item.file_name)})`}
                  value={item.load_id}
                  checked={
                    appliedFilters.load_id?.includes(item.load_id) &&
                    appliedFilters.file_type?.includes(
                      extractFileName(item.file_name)
                    )
                  }
                  onChange={(e) =>
                    handleSelectChange(e, extractFileName(item.file_name))
                  }
                  style={{ width: "350px" }}
                />
              ))}
            </Form>
          </Dropdown.Menu>
        </Dropdown>

        <div className="status-Filter-values d-flex gap-2">
          {breadCrumbs.map((breadCrumb) =>
            appliedFilters[breadCrumb.key]?.length > 0 ? (
              <div className={`${breadCrumb.key}-value d-flex`}>
                <p className="ellpsis">
                  {" "}
                  {breadCrumb.label}:
                  {appliedFilters[breadCrumb.key].map((items) => items + ",")}{" "}
                </p>
                <span
                  onClick={() => handleBreadCrumbClose(breadCrumb.key)}
                  className="close-filter-btn"
                >
                  <img src={CloseFilter} alt="Close" />
                </span>
              </div>
            ) : null
          )}
        </div>
      </div>
      <div className="navbar-right-section">
        <div className="filter-wrapper" onClick={toggleModal}>
          <span>Filters</span>
          {/* <img src={filterlines} alt="filterlines" /> */}
          <FilterLines />
        </div>
        <span className="workflow-refresh-btn" onClick={handleRefreshClick}>
          <strong>Refresh Data</strong>
          <span>
            <img src={refresh} alt="img" />
          </span>
        </span>
        <div className="search-bar">
          <img src={SearchIcon} alt="search-icon" className="search-icon" />
          <input
            className="audit-search"
            type="text"
            placeholder="Search by Patient Episode Identifier"
            onKeyDown={handleKeyPress}
            value={searchEpisodeIdentifier}
            onChange={handleSearch}
          />
          <div className="search-recommendations">
          {isRecommendationsLoading ? (
    <div className="loader"><Spinner/></div> 
  ) : (
    recommendations?.map((item, idx) => (
      <li
        key={idx}
        onClick={() => handleSearchRecommendClick(item.episode_identifier)}
        className="search-recommendation"
      >
        {item.episode_identifier}
      </li>
    ))
  )}
          </div>
        </div>
      </div>
      {/*  Modal */}
      <WorkFlowFilters
        showModal={showModal}
        onApply={handleFilterClick}
        onCancel={toggleModal}
      />
    </div>
  );
}

export default Navbar;
